"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { getHawk } from "@app/lib/hawk/init-hawk";
import ErrorPageView from "@views/error";
const CustomError = t0 => {
  const $ = _c(4);
  const {
    error
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      const hawk = getHawk();
      if (hawk && error) {
        hawk.send(error);
      }
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ErrorPageView />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default CustomError;